export const PREBOOK_EXIT_ROUTES = [
  // '/',
  '/blog/[slug]',
  '/crop/[id]/problem/[problemId]',
  '/ondc'
]


export const FARMER_APP_DEV_URL = 'https://farmer-app.dehat.co'
export const FARMER_APP_PROD_URL = 'https://farmer.dehaat.in'